import InfoIcon from '@mui/icons-material/Info';
import { Typography } from '@mui/material';

const Porcentajes = ({
    porcentaje,
    height = '20px',
    width = '20px',
    fontSize = 8,
    comentario,
    leftComentario = -15,
    ...props
}) => {
    const numericText = porcentaje > 0 || porcentaje === 0 ? porcentaje : 0;

    const getBackgroundColor = () => {
        if (numericText >= 90) {
            return '#1a5a8d ';
        } else if (numericText >= 70) {
            return '#206945';
        } else if (numericText >= 50) {
            return '#A55113';
        } else {
            return '#963c3c';
        }
    };

    return (
        <>
            <Typography
                sx={{
                    background: getBackgroundColor(),
                    height: height,
                    width: width,
                    textAlign: 'center',
                    borderRadius: '4px',
                    color: '#fff',
                    border: '1px solid rgba(255, 255, 255, 0.2)',
                    fontSize: fontSize,
                    position: 'relative',
                    ...props,
                }}
            >
                {numericText}
                <Typography component={'span'} fontSize={fontSize} sx={{ color: '#fff' }}>
                    %
                </Typography>

                {comentario && (
                    <InfoIcon
                        sx={{
                            fontSize: 14,
                            color: '#fff',
                            borderRadius: '50%',
                            width: 12,
                            height: 12,
                            alignItems: 'center',
                            justifyContent: 'center',
                            zIndex: 1,
                            position: 'absolute',
                            left: leftComentario,
                            color: '#fff',
                            cursor: 'pointer',
                            '&:hover': {
                                opacity: 0.8,
                            },
                        }}
                    />
                )}
            </Typography>
        </>
    );
};

export default Porcentajes;
